export default __webpack_public_path__ + "static/media/469.0f6383fa.png";